var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-content',{attrs:{"code":"404","desc":"您已抵达未知之地,我方正在查找中","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }